import React from "react";
//import { Link } from "react-router-dom";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import {
  //   Typography,
  //   Button,
  //   Stack,
  Grid,
  Card,
  //  CardActions,
  CardContent,
  Box,
  IconButton,
} from "@mui/material";
import SFCharacter from "../Tools/SFCharacter.js";
//import StatsSvg from "./StatsSvg.tsx";
import type {
  ArchetypeDescrType,
  SkillDescrType,
  RulesetDescrType,
} from "../types.tsx";
import { Select, MenuItem } from "@mui/material";
import Badge from "@mui/material/Badge";

declare module "@mui/material/CardContent" {
  interface CardContentOwnProps {
    align: string;
  }
}
type SkillValueCardSFPropsType = {
  archetype?: ArchetypeDescrType;
  ruleset: RulesetDescrType;
  character: SFCharacter;
  skill: SkillDescrType;
  level: number;
  onChangeLevel: Function;
  onAddSubskill: Function;
  onRemoveSubskill: Function;
  subskillList?: any[];
  talentList?: any[];
  editable?: boolean; // unused
};

type skLevelType = {
  valName: number;
};
const skillLevels: skLevelType[] = [
  { valName: 0 },
  { valName: 1 },
  { valName: 2 },
  { valName: 3 },
  { valName: 4 },
  { valName: 5 },
  { valName: 6 },
  { valName: 7 },
  { valName: 8 },
  { valName: 9 },
  { valName: 10 },
  { valName: 11 },
  { valName: 12 },
];
// function composeText(el: skLevelType) {
//   return el.valName;
// }
const basicTalentPts = (rk: number) => {
  if (rk <= 3) return rk;
  if (rk <= 6) return 3 + (rk - 3) * 2;
  else return 9 + (rk - 6) * 3;
};

function SkillValueCardSF({
  archetype,
  ruleset,
  character,
  skill,
  level,
  onChangeLevel,
  editable,
}: SkillValueCardSFPropsType) {
  /*
                        <MUINumberFieldAdv
                            required={true}
                            lbl={skill.name}
                            name={skill.code}
                            value={level}
                            change={onChangeLevel}
                            cssClass={skill.type === 'advanced' ? "field_cont_adv" : "field_cont"}
                            //errList={ErrorList}
                            min={0}
                            max={12}
                            right
                            //left
                            small
                            //vertical
                        />
    */

  const archBonus =
    ruleset.skillsInit &&
    ruleset.skillsInit.filter(
      (el) => el.archetype_id === character.archetype_id
    );
  const talentPts =
    archBonus &&
      archBonus[0]?.bonus.filter((el) => el.skCode === skill.code).length > 0
      ? basicTalentPts(level) +
      archBonus[0]?.bonus.filter((el) => el.skCode === skill.code)[0].num
      : basicTalentPts(level);
  //console.log('---- SkillCard ', props);
  //const classes = useStyles();
  return (
    <Grid item xs={12} sm={12} md={12} lg={6} xl={3} key={"skill_" + character.id}>
      <Badge
        color="success"
        badgeContent={talentPts}
      >
        <Card
          sx={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            minWidth: "240px",
            minHeight: "140px",
          }}
        >
          <CardContent align="left" style={{ padding: "5px" }} >
            {
              talentPts > 0 ? (
                <Box
                  style={{
                    position: 'absolute',
                    top: '-20px',
                    right: '6px',
                    zIndex: '10',
                  }}
                >
                  <IconButton
                    aria-label="aggiungi talento"
                    onClick={() => console.log('clicked ')}
                    title='Aggiungi talento'
                  >
                    <AddCircleOutlineIcon />
                  </IconButton>
                </Box>

              ) : null
            }
            <div style={{ height: "30px" }}>
              <Select
                key={"sk_" + skill.code}
                name={skill.code}
                value={level}
                //label={label}
                onChange={(e) => onChangeLevel(skill.code, e.target.value)}
                variant="outlined"
                //style={{ minWidth: "220px" }}
                //style={{ minWidth: minWidth }}
                style={{
                  height: "100%",
                  float: "left",
                  width: "59px",
                  marginRight: "4px",
                  marginLeft: "-2px",
                  padding: "0px",
                  //fontSize: "12px"
                }}
                //readOnly={props.readonly && props.readonly === true ? true : false}
                size="small"
              //error={ErrorMsg.length > 0 ? true : false}
              >
                {skillLevels.map((el) => (
                  <MenuItem
                    key={"op_" + skill.name + "_" + el.valName}
                    value={el.valName}
                  //style={{color: el.valName===0?'lightgray':el.valName<2?'red':'black'}}
                  >
                    {el.valName}
                  </MenuItem>
                ))}
              </Select>
              <div
                style={{
                  //marginLeft: '10px',
                  fontSize: "14px",
                  height: "30px",
                  //float:'left',
                  lineHeight: "30px",
                  textDecoration:
                    skill.type === "advanced" ? "underline" : "normal",
                }}
              >
                {skill.name}
              </div>
            </div>
            <div>
              {
                // subskills and skill talents
              }
            </div>
          </CardContent>
        </Card>
      </Badge>
    </Grid>
  );
}

export default SkillValueCardSF;
